import { Routes as RouterRoutes, Route } from 'react-router-dom';
import PrivateRoute from './PrivateRoute.react';

// import Header from '#components/header/Header.react';
import Dashboard from '#components/dashboard/Dashboard.react';
import ProjectDashboard from '#components/dashboard/ProjectDashboard.react';
import PageNotFound from './PageNotFound.react';
import Users from '#components/users/Users.react';
import User from '#components/users/User.react';
import FeatureFlags from '#components/settings/FeatureFlags.react';
import Permissions from '#components/settings/Permissions.react';
import Constants from '#components/settings/Constants.react';
import MetaData from '#components/settings/MetaData.react';
import EmailTest from '#components/settings/EmailTest.react';
import PosillicoProjectIcons from '#components/settings/PosillicoProjectIcons.react';
import NavigationDesktop from '#components/navigation/NavigationDesktop.react';
import NavigationMobile from '#components/navigation/NavigationMobile.react';
import Page from '#components/pages/Page.react';
import PageComponents from '#components/ppc/page-components/PageComponents.react';
import Pages from '#components/pages/Pages.react';
import Article from '#components/articles/Article.react';
import Articles from '#components/articles/Articles.react';
import Contact from '#components/contacts/Contact.react';
import Contacts from '#components/contacts/Contacts.react';
import Asset from '#components/assets/Asset.react';
import Assets from '#components/assets/Assets.react';
import Popups from '#components/popup/Popups.react';
import Popup from '#components/popup/Popup.react';
import SEO from '#components/seo/SEO.react';
import Products from '#components/products/Products.react';
import PpcProduct from '#components/products/PpcProduct.page';
import PpcProductCategory from '#components/products/PpcProductCategory.page';
import Services from '#components/services/Services.react';
import PpcService from '#components/services/PpcService.react';
import PpcServiceCategory from '#components/services/PpcServiceCategory.react';
import Association from '#components/affiliates-associations/Association.react';
import Associations from '#components/affiliates-associations/Associations.react';
import PpcClient from '#components/ppc-clients/PpcClient.react';
import PpcClients from '#components/ppc-clients/PpcClients.react';
import FaqList from '#components/faq/FaqList.react';
import Faq from '#components/faq/Faq.react';
import ContactPersons from '#components/contact-persons/ContactPersons.react';
import ContactPerson from '#components/contact-persons/ContactPerson.react';
import Locations from '#components/locations/Locations.react';
import Location from '#components/locations/Location.react';
import Testimonials from '#components/testimonials/Testimonials.react';
import Testimonial from '#components/testimonials/Testimonial.react';
import FormGroups from '#components/forms/FormGroups.react';
import FormGroupDetails from '#components/forms/FormGroupDetails.react';
import SiteSettings from '#components/site-settings/SiteSettings.react';
import ConstruxHomeSlider from '#components/construx/HomeSlider.react';
var Routes = function Routes() {
  return /*#__PURE__*/React.createElement("div", {
    className: "page"
  }, /*#__PURE__*/React.createElement(RouterRoutes, null, /*#__PURE__*/React.createElement(Route, {
    path: "/",
    element: /*#__PURE__*/React.createElement(PrivateRoute, {
      element: /*#__PURE__*/React.createElement(Dashboard, null)
    })
  }), /*#__PURE__*/React.createElement(Route, {
    path: "/:app/dashboard/:itemID",
    element: /*#__PURE__*/React.createElement(PrivateRoute, {
      element: /*#__PURE__*/React.createElement(ProjectDashboard, null)
    })
  }), /*#__PURE__*/React.createElement(Route, {
    path: "/:app/dashboard",
    element: /*#__PURE__*/React.createElement(PrivateRoute, {
      element: /*#__PURE__*/React.createElement(ProjectDashboard, null)
    })
  }), /*#__PURE__*/React.createElement(Route, {
    path: "/:app/desktop-navigation/:itemID",
    element: /*#__PURE__*/React.createElement(PrivateRoute, {
      element: /*#__PURE__*/React.createElement(NavigationDesktop, null)
    })
  }), /*#__PURE__*/React.createElement(Route, {
    path: "/:app/desktop-navigation/",
    element: /*#__PURE__*/React.createElement(PrivateRoute, {
      element: /*#__PURE__*/React.createElement(NavigationDesktop, null)
    })
  }), /*#__PURE__*/React.createElement(Route, {
    path: "/:app/pages/:itemID",
    element: /*#__PURE__*/React.createElement(PrivateRoute, {
      element: /*#__PURE__*/React.createElement(Pages, null)
    })
  }), /*#__PURE__*/React.createElement(Route, {
    path: "/:app/pages",
    element: /*#__PURE__*/React.createElement(PrivateRoute, {
      element: /*#__PURE__*/React.createElement(Pages, null)
    })
  }), /*#__PURE__*/React.createElement(Route, {
    path: "/:app/mobile-navigation/:itemID",
    element: /*#__PURE__*/React.createElement(PrivateRoute, {
      element: /*#__PURE__*/React.createElement(NavigationMobile, null)
    })
  }), /*#__PURE__*/React.createElement(Route, {
    path: "/:app/mobile-navigation/",
    element: /*#__PURE__*/React.createElement(PrivateRoute, {
      element: /*#__PURE__*/React.createElement(NavigationMobile, null)
    })
  }), /*#__PURE__*/React.createElement(Route, {
    path: "/:app/page/:pageID",
    element: /*#__PURE__*/React.createElement(PrivateRoute, {
      element: /*#__PURE__*/React.createElement(Page, null)
    })
  }), /*#__PURE__*/React.createElement(Route, {
    path: "/:app/page-components/:pageID",
    element: /*#__PURE__*/React.createElement(PrivateRoute, {
      element: /*#__PURE__*/React.createElement(PageComponents, null)
    })
  }), /*#__PURE__*/React.createElement(Route, {
    path: "/:app/articles/:itemID",
    element: /*#__PURE__*/React.createElement(PrivateRoute, {
      element: /*#__PURE__*/React.createElement(Articles, null)
    })
  }), /*#__PURE__*/React.createElement(Route, {
    path: "/:app/articles",
    element: /*#__PURE__*/React.createElement(PrivateRoute, {
      element: /*#__PURE__*/React.createElement(Articles, null)
    })
  }), /*#__PURE__*/React.createElement(Route, {
    path: "/:app/seo",
    element: /*#__PURE__*/React.createElement(PrivateRoute, {
      element: /*#__PURE__*/React.createElement(SEO, null)
    })
  }), /*#__PURE__*/React.createElement(Route, {
    path: "/:app/article/:articleID",
    element: /*#__PURE__*/React.createElement(PrivateRoute, {
      element: /*#__PURE__*/React.createElement(Article, null)
    })
  }), /*#__PURE__*/React.createElement(Route, {
    path: "/article/:articleID",
    element: /*#__PURE__*/React.createElement(PrivateRoute, {
      element: /*#__PURE__*/React.createElement(Article, null)
    })
  }), /*#__PURE__*/React.createElement(Route, {
    path: "/:app/popups/:itemID",
    element: /*#__PURE__*/React.createElement(PrivateRoute, {
      element: /*#__PURE__*/React.createElement(Popups, null)
    })
  }), /*#__PURE__*/React.createElement(Route, {
    path: "/:app/popups",
    element: /*#__PURE__*/React.createElement(PrivateRoute, {
      element: /*#__PURE__*/React.createElement(Popups, null)
    })
  }), /*#__PURE__*/React.createElement(Route, {
    path: "/:app/products",
    element: /*#__PURE__*/React.createElement(PrivateRoute, {
      element: /*#__PURE__*/React.createElement(Products, null)
    })
  }), /*#__PURE__*/React.createElement(Route, {
    path: "/:app/product/:productID",
    element: /*#__PURE__*/React.createElement(PrivateRoute, {
      element: /*#__PURE__*/React.createElement(PpcProduct, null)
    })
  }), /*#__PURE__*/React.createElement(Route, {
    path: "/:app/product-category/:categoryID",
    element: /*#__PURE__*/React.createElement(PrivateRoute, {
      element: /*#__PURE__*/React.createElement(PpcProductCategory, null)
    })
  }), /*#__PURE__*/React.createElement(Route, {
    path: "/:app/services",
    element: /*#__PURE__*/React.createElement(PrivateRoute, {
      element: /*#__PURE__*/React.createElement(Services, null)
    })
  }), /*#__PURE__*/React.createElement(Route, {
    path: "/:app/service/:serviceID",
    element: /*#__PURE__*/React.createElement(PrivateRoute, {
      element: /*#__PURE__*/React.createElement(PpcService, null)
    })
  }), /*#__PURE__*/React.createElement(Route, {
    path: "/:app/service-category/:categoryID",
    element: /*#__PURE__*/React.createElement(PrivateRoute, {
      element: /*#__PURE__*/React.createElement(PpcServiceCategory, null)
    })
  }), /*#__PURE__*/React.createElement(Route, {
    path: "/:app/affiliates-associations/:associationID",
    element: /*#__PURE__*/React.createElement(PrivateRoute, {
      element: /*#__PURE__*/React.createElement(Association, null)
    })
  }), /*#__PURE__*/React.createElement(Route, {
    path: "/:app/affiliates-associations",
    element: /*#__PURE__*/React.createElement(PrivateRoute, {
      element: /*#__PURE__*/React.createElement(Associations, null)
    })
  }), /*#__PURE__*/React.createElement(Route, {
    path: "/:app/clients/:clientID",
    element: /*#__PURE__*/React.createElement(PrivateRoute, {
      element: /*#__PURE__*/React.createElement(PpcClient, null)
    })
  }), /*#__PURE__*/React.createElement(Route, {
    path: "/:app/clients",
    element: /*#__PURE__*/React.createElement(PrivateRoute, {
      element: /*#__PURE__*/React.createElement(PpcClients, null)
    })
  }), /*#__PURE__*/React.createElement(Route, {
    path: "/:app/faq/:faqID",
    element: /*#__PURE__*/React.createElement(PrivateRoute, {
      element: /*#__PURE__*/React.createElement(Faq, null)
    })
  }), /*#__PURE__*/React.createElement(Route, {
    path: "/:app/faq",
    element: /*#__PURE__*/React.createElement(PrivateRoute, {
      element: /*#__PURE__*/React.createElement(FaqList, null)
    })
  }), /*#__PURE__*/React.createElement(Route, {
    path: "/:app/testimonial/:testimonialID",
    element: /*#__PURE__*/React.createElement(PrivateRoute, {
      element: /*#__PURE__*/React.createElement(Testimonial, null)
    })
  }), /*#__PURE__*/React.createElement(Route, {
    path: "/:app/testimonials",
    element: /*#__PURE__*/React.createElement(PrivateRoute, {
      element: /*#__PURE__*/React.createElement(Testimonials, null)
    })
  }), /*#__PURE__*/React.createElement(Route, {
    path: "/:app/forms/:formGroupID",
    element: /*#__PURE__*/React.createElement(PrivateRoute, {
      element: /*#__PURE__*/React.createElement(FormGroupDetails, null)
    })
  }), /*#__PURE__*/React.createElement(Route, {
    path: "/:app/forms",
    element: /*#__PURE__*/React.createElement(PrivateRoute, {
      element: /*#__PURE__*/React.createElement(FormGroups, null)
    })
  }), /*#__PURE__*/React.createElement(Route, {
    path: "/:app/contact-person/:contactID",
    element: /*#__PURE__*/React.createElement(PrivateRoute, {
      element: /*#__PURE__*/React.createElement(ContactPerson, null)
    })
  }), /*#__PURE__*/React.createElement(Route, {
    path: "/:app/contact-persons",
    element: /*#__PURE__*/React.createElement(PrivateRoute, {
      element: /*#__PURE__*/React.createElement(ContactPersons, null)
    })
  }), /*#__PURE__*/React.createElement(Route, {
    path: "/:app/location/:locationID",
    element: /*#__PURE__*/React.createElement(PrivateRoute, {
      element: /*#__PURE__*/React.createElement(Location, null)
    })
  }), /*#__PURE__*/React.createElement(Route, {
    path: "/:app/locations",
    element: /*#__PURE__*/React.createElement(PrivateRoute, {
      element: /*#__PURE__*/React.createElement(Locations, null)
    })
  }), /*#__PURE__*/React.createElement(Route, {
    path: "/:app/site-settings",
    element: /*#__PURE__*/React.createElement(PrivateRoute, {
      element: /*#__PURE__*/React.createElement(SiteSettings, null)
    })
  }), /*#__PURE__*/React.createElement(Route, {
    path: "/construx/home-slider",
    element: /*#__PURE__*/React.createElement(PrivateRoute, {
      element: /*#__PURE__*/React.createElement(ConstruxHomeSlider, null)
    })
  }), /*#__PURE__*/React.createElement(Route, {
    path: "/popup/:popupID",
    element: /*#__PURE__*/React.createElement(PrivateRoute, {
      element: /*#__PURE__*/React.createElement(Popup, null)
    })
  }), /*#__PURE__*/React.createElement(Route, {
    path: "/users",
    element: /*#__PURE__*/React.createElement(PrivateRoute, {
      element: /*#__PURE__*/React.createElement(Users, null)
    })
  }), /*#__PURE__*/React.createElement(Route, {
    path: "/user/:userID",
    element: /*#__PURE__*/React.createElement(PrivateRoute, {
      element: /*#__PURE__*/React.createElement(User, null)
    })
  }), /*#__PURE__*/React.createElement(Route, {
    path: "/contact/:id",
    element: /*#__PURE__*/React.createElement(PrivateRoute, {
      element: /*#__PURE__*/React.createElement(Contact, null)
    })
  }), /*#__PURE__*/React.createElement(Route, {
    path: "/contacts",
    element: /*#__PURE__*/React.createElement(PrivateRoute, {
      element: /*#__PURE__*/React.createElement(Contacts, null)
    })
  }), /*#__PURE__*/React.createElement(Route, {
    path: "/settings/feature-flags",
    element: /*#__PURE__*/React.createElement(PrivateRoute, {
      element: /*#__PURE__*/React.createElement(FeatureFlags, null)
    })
  }), /*#__PURE__*/React.createElement(Route, {
    path: "/settings/constants",
    element: /*#__PURE__*/React.createElement(PrivateRoute, {
      element: /*#__PURE__*/React.createElement(Constants, null)
    })
  }), /*#__PURE__*/React.createElement(Route, {
    path: "/settings/meta-data",
    element: /*#__PURE__*/React.createElement(PrivateRoute, {
      element: /*#__PURE__*/React.createElement(MetaData, null)
    })
  }), /*#__PURE__*/React.createElement(Route, {
    path: "/settings/permissions",
    element: /*#__PURE__*/React.createElement(PrivateRoute, {
      element: /*#__PURE__*/React.createElement(Permissions, null)
    })
  }), /*#__PURE__*/React.createElement(Route, {
    path: "/asset/:assetID",
    element: /*#__PURE__*/React.createElement(PrivateRoute, {
      element: /*#__PURE__*/React.createElement(Asset, null)
    })
  }), /*#__PURE__*/React.createElement(Route, {
    path: "/assets",
    element: /*#__PURE__*/React.createElement(PrivateRoute, {
      element: /*#__PURE__*/React.createElement(Assets, null)
    })
  }), /*#__PURE__*/React.createElement(Route, {
    path: "/settings/project-icons",
    element: /*#__PURE__*/React.createElement(PrivateRoute, {
      element: /*#__PURE__*/React.createElement(PosillicoProjectIcons, null)
    })
  }), /*#__PURE__*/React.createElement(Route, {
    path: "/settings/email-test",
    element: /*#__PURE__*/React.createElement(PrivateRoute, {
      element: /*#__PURE__*/React.createElement(EmailTest, null)
    })
  }), /*#__PURE__*/React.createElement(Route, {
    path: "/404",
    element: /*#__PURE__*/React.createElement(PrivateRoute, {
      element: /*#__PURE__*/React.createElement(PageNotFound, null)
    })
  }), /*#__PURE__*/React.createElement(Route, {
    path: "*",
    element: /*#__PURE__*/React.createElement(PrivateRoute, {
      element: /*#__PURE__*/React.createElement(PageNotFound, null)
    })
  })));
};
export default Routes;